const EXPAND_SIDEBAR = 'EXPAND_SIDEBAR';
const COLLAPSE_SIDEBAR = 'COLLAPSE_SIDEBAR';
const TOGGLE_SIDEBAR_TOGGLE = 'TOGGLE_SIDEBAR_TOGGLE';

export {
  EXPAND_SIDEBAR,
  COLLAPSE_SIDEBAR,
  TOGGLE_SIDEBAR_TOGGLE,
};
